import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'
import CustomSnackBar from '../../../../../shared/components/CustomSnackBar'
import ScreenLoading from '../../../../../shared/components/ScreenLoading'

function NoveltiesDetailNotifications() {
  const { loading, error, msg } = useSelector((state: IRootState) => state.novelty)

  return (
    <>
      <CustomSnackBar errors={[error]} msgs={[msg]} />
      <ScreenLoading loadings={[loading]} />
    </>
  )
}

export default NoveltiesDetailNotifications
